export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/scarf-9b560a745af794e271426d208c05d0bc.png";